export const clearURL = (url) => {
    return url ? new URL(url).origin : '';
};
export const clearErrorEvent = (event) => {
    if (event.request?.url) {
        event.request.url = clearURL(event.request.url);
    }
    if (event.transaction) {
        event.transaction = window.location.host;
    }
};
export const clearBreadcrumb = (breadcrumb) => {
    if (breadcrumb.data?.url) {
        breadcrumb.data.url = clearURL(breadcrumb.data.url);
    }
};
export const clearTransaction = (event) => {
    if (event.request?.url) {
        event.request.url = clearURL(event.request.url);
    }
    if (event.transaction) {
        event.transaction = window.location.host;
    }
};
